import React,{useEffect,useState,useRef,useCallback} from 'react'
import {Link} from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import _ from 'lodash'
import { BASE_URL } from '../Config/Base';
import loader from '../Assets/Images/Loading_icon.gif'
// import { ClipLoader,PulseLoader,FadeLoader} from 'react-spinners';


const pageSize = 3;

const  FoundAdduserMain=()=>{

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [allusers, setAllusers] = useState([])

   const [paginatedPosts, setpaginatedPosts] = useState();
   //const [currentPage, setcurrentPage] = useState(1);

  const[pop,setpop] = useState(false);

  const[Roletable, setRoletable] =useState([])  
 

  useEffect(()=>{
    getRole();
   
  },[])

 /*---Get Roles ----*/

function getRole(){


    fetch(`${BASE_URL}/Foundation/FoundationGetRoles`, {
      method:'GET',

    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " +`${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


})

          .then(response => response.json())


            .then(data => {
             console.log("Role",data)
             setRoletable(data)
              localStorage.setItem("Data", JSON.stringify(data));
           
            });
           }

  // function ActiveIndicator(){

  //   document.getElementById("activity-indicator").style.display = "none";
   
  //  }
  
   
  //  useEffect(() => {
  //   setTimeout(() => {
  //      ActiveIndicator();
  //   }, 1000);
  // }, [])


    useEffect(() => {
    setpop(true);
    document.getElementById('showtable').style.display='none'
    setTimeout(() => {
    setpop(false);
    fetchgetmethod();
    document.getElementById('showtable').style.display='block'
    }, 1000);
    }, [])

 function fetchgetmethod(){
 
  console.log("Token", token)
  
  fetch(`${BASE_URL}/Foundation/Getfoundationusers`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())
       

    .then(data => {
      console.log("Data", data)
      // document.getElementById("activity-indicator").style.display = "none";
      // ActiveIndicator();
      setAllusers(data);
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      localStorage.setItem("paginationData", JSON.stringify(data));    
    }
    );

console.log("check",allusers)
  
  }  

// const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
// // if (pageCount === 1)
// // return null;

// const pages = _.range(1, pageCount+1)

// const pagination =(pageNo)=>{
// setcurrentPage(pageNo);
// const startIndex = (pageNo - 1) * pageSize;
// const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
// setpaginatedPosts(paginatedPost)
// }
 


/*Integration of Register*/

const fetchdata=()=>{
    
    let data = {
      username:document.getElementById('username').value,
      email:document.getElementById('email').value,
      password:document.getElementById('password').value,
      role:document.getElementById('roleid').value,
      roleid:"02",
      ventureid:'04',
      active:'0',
      deletestatus:'0',
      assignstatus:'0',
      ventureName:'Kdp Foundation'
    }
console.log("data",data)
   
    const token = JSON.parse(localStorage.getItem('usertoken'));
    axios({

        method:"POST",
        url:`${BASE_URL}/Authenticate/Register`,
        data:data,
        headers: {
          "Content-Type" : "application/json",
          "Authorization": "Bearer " + `${token}`,
        }

    })
    .then((response) =>{
      console.log(response.data);
      
      if(response.data.status === "Success"){
        alert("Registered Successfully! Please Go and check your mail to Activate Your Account !")
        fetchgetmethod();
        closeForm();

        // toast.success("Registered Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
       
       }

       else if(response.data.status === "Already"){
        
        alert("User Already Exist !");
        // toast.error("User Already Exist !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
          
      }
   
      else if(response.data.status === "Empty"){

        alert("User Creation failed !");
        //   toast.error("User creation failed !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
          

      }
     
    })
.catch(error => {
  console.log(error);
 alert("User creation failed !")
 
})
}

/*Validation*/

const Validate=(e)=>{
e.preventDefault();

// const hashedpassword = bcrypt.hashSync(Password,10);
// console.log(hashedpassword)

const Username = document.getElementById("username").value;
const Email = document.getElementById("email").value;
const Email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const Password = document.getElementById("password").value;
const Password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
const Role = document.getElementById("roleid").value;

if(!Username)
{
  document.getElementById("usererrorA").innerHTML = "Username Required ";
}
else if(Username.length<3)
{
  
  document.getElementById("usererrorA").innerHTML = " ";
  document.getElementById("usererrorB").innerHTML = "Enter atleast 3 characters";
}
else
{
  document.getElementById("usererrorA").innerHTML = " ";
  document.getElementById("usererrorB").innerHTML = "";
}

if(!Email)
{
  document.getElementById("mailerrorA").innerHTML = " Email Required ";
}
else if (Email1.test(Email)===false)
{
  
  document.getElementById("mailerrorA").innerHTML = " ";
  document.getElementById("mailerrorB").innerHTML = " Invalid Email ";
}
else
{
  document.getElementById("mailerrorA").innerHTML = " ";
  document.getElementById("mailerrorB").innerHTML = " ";
}

if(!Password)
{
  document.getElementById("passerrorA").innerHTML = " Password Required ";
}
else if (Password1.test(Password)===false)
{
  document.getElementById("passerrorA").innerHTML = " ";
  document.getElementById("passerrorB").innerHTML = " Please Enter atleast 8 characters one number, one Uppercase,one Lowercase and one Special Character ";
}
else
{
  document.getElementById("passerrorA").innerHTML = " ";
  document.getElementById("passerrorB").innerHTML = " ";
}

if(!Role)
{
  document.getElementById("roleerrorA").innerHTML = " This field is Required ";
}
else
{
  document.getElementById("roleerrorA").innerHTML = " ";
}
if((Username.length>=3) && (Email1.test(document.getElementById("email").value)===true) && (Password1.test(document.getElementById("password").value)===true) && Role  ){
 fetchdata();
}

}

/*Remove Error*/

const Remove =(e)=>{

  e.preventDefault();

  const Username = document.getElementById("username").value;
  const Email = document.getElementById("email").value;
  const Email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const Password = document.getElementById("password").value;
  const Password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const Role = document.getElementById("roleid").value;
  
  if(!Username)
  {
    document.getElementById("usererrorA").innerHTML = " Username Required ";
    document.getElementById("usererrorB").innerHTML = " ";
  }
  else if(Username.length<3)
  {
    
    document.getElementById("usererrorA").innerHTML = " ";
    document.getElementById("usererrorB").innerHTML = "Enter atleast 3 characters";
  }
  else
  {
    document.getElementById("usererrorA").innerHTML = " ";
    document.getElementById("usererrorB").innerHTML = "";
  }
  
  if(!Email)
  {
    document.getElementById("mailerrorA").innerHTML = " Email Required ";
    document.getElementById("mailerrorB").innerHTML = "  ";
  }
  else if (Email1.test(Email)===false)
  {
    
    document.getElementById("mailerrorA").innerHTML = " ";
    document.getElementById("mailerrorB").innerHTML = " Invalid Email ";
  }
  else
  {
    document.getElementById("mailerrorA").innerHTML = " ";
    document.getElementById("mailerrorB").innerHTML = " ";
  }
  
  if(!Password)
  {
    document.getElementById("passerrorA").innerHTML = " Password Required ";
    document.getElementById("passerrorB").innerHTML = "  ";
  }
  else if (Password1.test(Password)===false)
  {
    document.getElementById("passerrorA").innerHTML = " ";
    document.getElementById("passerrorB").innerHTML = "Please Enter atleast 8 characters one number, one Uppercase,one Lowercase and one Special Character ";
  }
  else
  {
    document.getElementById("passerrorA").innerHTML = " ";
    document.getElementById("passerrorB").innerHTML = " ";
  }
  
  if(!Role)
  {
    document.getElementById("roleerrorA").innerHTML = " This field is Required ";
  }
  else
  {
    document.getElementById("roleerrorA").innerHTML = " ";
  }
  
}


/*Form Clear*/
function openForm()
{

   document.getElementById("modalRegisterForm").style.display = "block";
 }

 function closeForm()

 {

  document.getElementById("usererrorA").innerHTML = " ";
  document.getElementById("usererrorB").innerHTML = " ";
  document.getElementById("mailerrorA").innerHTML = " ";
  document.getElementById("mailerrorB").innerHTML = " ";
  document.getElementById("passerrorA").innerHTML = " ";
  document.getElementById("passerrorB").innerHTML = " ";
  document.getElementById("roleerrorA").innerHTML = " ";
  document.getElementById("form").reset(); 
  document.getElementById("modalRegisterForm").style.display = "none";

 }



 function hide(){

  var x = document.getElementById("password");
  var eye = document.getElementById("eye");

  if(x.type === "password"){

    x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
  }

  else
  {
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")
  }

 }


 function ActiveStatus(Id,active,UserName){

   
  const body ={
   id: Id
 }

  console.log(body)
   axios({
  
   method:"POST",
  url:`${BASE_URL}/Foundation/ActiveStatus`,
  data:body,
  headers: {
  "Content-Type" : "application/json",
  "Authorization": "Bearer " + `${token}`

  }
 
   })
   .then((response) =>{
   console.log(response.data);
   fetchgetmethod();
   if(active != 0) {
   toast.success(UserName +" "+"Activated Successfully !", {
    position: "top-center",
    autoClose: 3200,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'toast-message'
    });

   }

   else if(active == 0){
    toast.success("InActivated Successfully !", {
      position: "top-center",
      autoClose: 3200,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      className: 'toast-message'
      });
   
   }
   

   })

   } 
   
   
   //  DeleteStatus

    

    function ConfirmDelete(Id){
             
      SelectParticular(Id)
     document.getElementById("modaldeleteForm").style.display = "block";

   }

    const DeleteStatus=(Id,UserName)=>{
  
    const body ={
     id: Id,
   }

    console.log(body)
    
     axios({
    
     method:"POST",
    url:`${BASE_URL}/Foundation/DeleteStatus`,
    data:body,
    headers: {
    "Content-Type" : "application/json",
    "Authorization": "Bearer " + `${token}`
 
    }
   
     })
     .then((response) =>{
     console.log(response.data);
      fetchgetmethod();
      closeEditform();
      // setcurrentPage(1);
      if(response.data.status === "Success"){
        alert( UserName +"  "+ "Deleted" +"  "+ "Successfully !");
      // toast.success( "Deleted" + "  " + UserName + "Successfully !", {
      // position: "top-center",
      // autoClose: 3200,
      // hideProgressBar: false,
      // closeOnClick: true,
      // pauseOnHover: true,
      // draggable: true,
      // progress: undefined,
      // className: 'toast-message'
     
      // });

    } 

     })
  
     }


     function FoundEditUser(Id){

        // let EditData = JSON.parse(localStorage.getItem(EditData));
       localStorage.getItem("EditData");

       SelectParticular(Id);

       setTimeout(()=>{
        window.location.href="/?#/FoundEditPop"
      },1000)

    }

     /*select particular user*/
     const [EditUser, setEditUser] = useState([])

     function SelectParticular(Id){

    // document.getElementById("EditUserPop").style.display = "block";
 
    const body =
     {
       
      id:Id

     }
     console.log('body',body);

   
     axios({
            method:"POST",
            url :`${BASE_URL}/Foundation/FoundationEditUser`,
            data:body, 
            headers:{
                 "Content-type": "application/json",
                 "Authorization": "Bearer " + `${token}`,
  
             }     
         }) 
         
    
         .then((response) =>{
           console.log(response.data);
           setEditUser(response.data);
           localStorage.setItem("EditData",JSON.stringify(response.data))
      
        })
        .catch(error => {
          console.log(error);
          
        })

     }


     
          //function edit

      
          function openEdit(Id){
            
            document.getElementById("EditUserPop").style.display = "block";


            // SelectParticular(Id)
      
          }

          const handleActive=()=>{
            setActive(1);
          }

          const [Active, setActive] =useState('0')

          const handleInActive=()=>{
            setInActive(0);
          }
          
          const [InActive, setInActive] =useState('1')


       function UpdateUser(Id,ActiveState){

      if(ActiveState==0){

        var Action =Active
       }
       else{
        var Action=InActive

       }

      var Username = document.getElementById("textUsername").value;
      // var Email = document.getElementById("textEmail").value;

      if(!Username){

        document.getElementById("textUsername").innerHTML="UserName Required";
       }
  
       else if(Username){
        document.getElementById("textUsername").innerHTML=" ";
  

   const body =
    {
      UserName:Username, 
      Id:Id,
      active:Action 
    }


    console.log('body',body);

    
    axios({
           method:"POST",
           url :`${BASE_URL}/Foundation/FoundationUpdateUser`,
           data:body, 
           headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": "Bearer " + `${token}`,
            }     
        }) 

       .then((response) =>{
       console.log(response.data);
      
  
       if(response.data.status === "Success"){
       
            toast.success("Section Updated")
            // fetchgetmethod();
            closeEditform();
           
          }
          fetchgetmethod();
    })
    .catch(error => {
      console.log(error);
    //  alert("failed !")
    toast.warning("failed to Update")   
    })
  
  }

  }
  
     function closeEditform(){
      
      // document.getElementById("EditUserPop").style.display = "none";
      document.getElementById("modaldeleteForm").style.display ="None"
      document.getElementById("form").reset();
    }

    function addrole()
    {
      
        window.location.href="/?#/FoundAddRole"
    }

    
    const LEFT_PAGE = "LEFT";
    const RIGHT_PAGE = "RIGHT";
    const range = (from, to, step = 1) => {
      let i = from;
      const range = [];
    
      while (i <= to) {
        range.push(i);
        i += step;
      }
    
      return range;
    };
     const [currentPage, setCurrentPage] = useState(1);

    let data = localStorage.getItem("paginationData")
    let transdata =  JSON.parse(data);
    let NUM_OF_RECORDS = transdata.length;
    let LIMIT = 5;
    
    const onPageChanged = useCallback(
    
      (event, page) => {
        event.preventDefault();
        setCurrentPage(page);
      },
      [setCurrentPage]
      
    );
    
    
    const currentData = transdata.slice(
      (currentPage - 1) * LIMIT,
      (currentPage - 1) * LIMIT + LIMIT
    );
    
    const Paginations = (props) => {
      const {
        totalRecords,
        pageLimit,
        pageNeighbours,
        onPageChanged,
        currentPage
      } = props;
      const [totalPages, setTotalPages] = useState(0);
      useEffect(() => {
        setTotalPages(Math.ceil(totalRecords / pageLimit));
      }, [setTotalPages]);
    
      const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 1 + 0;
        console.log(totalNumbers)
        console.log(pageNeighbours)
        const totalBlocks = totalNumbers + 2;
        console.log(totalBlocks)
    
        if (totalPages > totalBlocks) {
          const startPage = Math.max(2, currentPage - pageNeighbours);
          const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    
          let pages = range(startPage, endPage);
    
          const hasLeftSpill = startPage > 2;
          const hasRightSpill = totalPages - endPage > 1;
          const spillOffset = totalNumbers - (pages.length + 1);
    
          switch (true) {
            case hasLeftSpill && !hasRightSpill: {
              const extraPages = range(startPage - spillOffset, startPage - 1);
              pages = [LEFT_PAGE, ...extraPages, ...pages];
              break;
            }
            case hasLeftSpill && hasRightSpill:
            default: {
              pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
              break;
            }
          }
          return [1, ...pages, totalPages];
        }
        return range(1, totalPages);
      };
    
    
      const pages = fetchPageNumbers() || [];
      return (
        <nav aria-label="Countries Pagination" id='foundnavpag'>
          <ul className="pagination">
            {pages.map((page, index) => {
              if (page === LEFT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      href="/"
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                );
    
              if (page === RIGHT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      className="page-link"
                      href="/"
                      aria-label="Next"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 1)}
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                );
    
              return (
                <li
                  key={index}
                  className={`page-item${currentPage === page ? " active" : ""}`}
                >
                  <a
                    className="page-link"
                    href="/"
                    onClick={(e) => onPageChanged(e, page)}
                  >
                    {page}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    };

  return(
    
    <div className='foundation-addmain'>
    <ToastContainer
     id="toast"
     position="top-center"
     autoClose={1500}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
    draggable
    pauseOnHover
    />

    <div className="foundation-addgrid-layout" >
    <div className="foundation-addmain-top animate-top" >
    <div className='foundation-addmain-back'>
    <Link to='/Kdp Foundation'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Users</span>
    </div>
    </div>
   
    <div className='foundation-addmain-add'>
      <button className='add-user' onClick={openForm}>  
      <i class="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add User</button>
    </div>

     
    <div className='foundation-addmain-role'>
      <button className='add-user' onClick={addrole}>
        <i class="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add Role
      </button>
    </div>


    {/* <div className='foundation-pop-fade' id="activity-indicator" style={{display:"block"}}>
    <FadeLoader id='activity' 
     color={'white'}
     width={5}
     height={15}
     aria-label="Loading Spinner"
     data-testid="loader"
     />
    </div> */}

    <div className="foundation-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
   <div className="modal-dialog" role="document">
    <div className="modal-content"  style={{marginTop:"160px"}}>
      <div className="modal-header  text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form' onSubmit={Validate}>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
          <input type="text"  onKeyUp={Remove}  className="form-control validate" placeholder='Username' id="username"/>
          <span className='error' id="usererrorA"></span>
          <span className='error' id="usererrorB"></span>
        </div>

        <div className="md-form mb-5">
          <input type="text"   onKeyUp={Remove}  className="form-control validate" placeholder='Email' id="email"/>
          <span className='error' id="mailerrorA"></span>
          <span className='error' id="mailerrorB"></span>
        </div>

        <div className="md-form mb-5">
        <div style={{display:"flex"}}>
          <input type="password" onKeyUp={Remove} className="form-control validate" placeholder='Password' id="password"/>
          <span className='foundation-adduser-eyeicon'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="eye"></i></span>
          </div>
          <span className='error' id="passerrorA"></span>
          <span className='error' id="passerrorB"></span>
        </div>

          <div className="md-form mb-4">
          <select name='roleid' onInputCapture={Remove} className='form-select' id="roleid">
          <option value=''> Role</option>
          {Roletable.map((e)=>
            {
              return <option value={e.roles}>{e.roles}</option>})}
          </select>
          <span className='error' id="roleerrorA"></span>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className="foundation-adduser-button" type='submit'>Submit</button>
  

      </div>
      </form>
      
    </div>
  </div>
</div>

 {pop?<div className='text-center'><img src={loader} alt="loader" id='loading-IndicatorAdduser'/></div>
 :null}


  {/* DeletePopup */}

  {EditUser.map((e)=>{ 
   return<div className="foundation-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content"  style={{marginTop:"280px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeEditform}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-0">
            <div className='text-center'>
          <h5>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="foundation-deleteuser-button"  onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Delete</button>
        <button className="foundation-deleteuser-button"  onClick={closeEditform} type='submit'>Cancel</button>
       </div>

      

       </form>
      
     </div>
    </div>
</div>})}

 {/*EditPop */}
{/* <div className='foundation-pop-fade' id="EditUserPop">

   {EditUser.map((e)=>{
    return<div className="modal-dialog" role="document">
    <div className="modal-content"> 
    <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT USER</h4>
        <button type="button" className="close" onClick={closeEditform}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div> 
  <form id='formA' onSubmit={()=>UpdateUser(e.id,e.active)}>
  <div className="modal-body mx-3">
  <div className="md-form mb-5">
  <input type="text"  id='textUsername' defaultValue={e.userName} ></input>
  </div> 

  <div className="md-form mb-5">
  <input type="text"  id='textEmail' defaultValue={e.email} readOnly ></input>
  </div> 

 


  <div className="md-form mb-5">
       
       {e.active==1 ? 
    
    <center>
    <input type="checkbox" id="foundinactiveswitch"
                 class="InActivecheckbox" onChange={handleInActive} />
     <label for="foundinactiveswitch" className="foundtoggleinactive">
          

  <p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;InActive</p>


     </label>
  
     </center>:
         
   
    
         <center>
         <input type="checkbox" id="foundactiveswitch"
                      className="Activecheckbox"  onChange={handleActive}/>
          <label for="foundactiveswitch" className="foundtoggleactive">
               
   
       <p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;InActive</p>
   
   
          </label>
       
          </center>
}
      
      </div>


  </div>
  
  <div className="modal-footer d-flex justify-content-center">
  <button type="submit"   id='foundation-section-buttonA'>Save</button>
  </div>
  
  </form>
  </div>
  </div>})}
 </div> */}

<div className='foundation-table'>
<div className="table_foundation-responsive " id='showtable'>
{/* 
 {
  !paginatedPosts ? (" "):( */}
    <table>
      <thead>
        <tr>
          <th>UserName</th>
          <th>Email</th>
          <th>Action</th>
          {/* <th>Generate Password</th> */}

        </tr>
      </thead>
    
      <tbody>
        {
         currentData.map((e,index)=> (
          <tr key={index}>
            <td>{e.userName}</td>
            <td>{e.email}</td>
            
            <td className='text-center'>
            <span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>FoundEditUser(e.id)} id="FoundEditicon"></i></span> &nbsp;&nbsp;
            <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="FoundDelicon" ></i></span>
            </td>

             {/* <td className='text-center'>{e.active==0?<button className='buttonA' id ='foundation-buttonA' onClick={()=>ActiveStatus(e.id,e.active)}>Active</button>:<button className='buttonB' id ='foundation-buttonB'  onClick={()=>ActiveStatus(e.id,e.active)}>Inactive</button>}
             &nbsp;&nbsp;<button id ='foundationDelete-button' onClick={()=>DeleteStatus(e.id,e.userName)}>Delete</button></td> */}

            {/* <td>{e.password}</td> */}
         </tr>
        ))

        }
      </tbody>
   
    </table>
   {/* )}  */}

 
  <br></br>
  {transdata.length<=5? null:<div>{

!paginatedPosts ? (""):(

  <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={1}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          /> 
    )}
          </div>
}
{/* 
    <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav>   */}

</div>
</div>

</div>

   
  )
}

export default FoundAdduserMain